export const knobDiameter = 64;
export const planSectionWidth = 83;
export const planSectionMinimalWidth = 50;
export const planSectionHeight = 48;
export const planContainerWidth = 30;
export const planContainerHeight = 30;
export const knobShift = (planSectionWidth - knobDiameter) / 2;
export const trackPaddingSize = 32;